import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { ValidateOPTOPHModel } from 'components/Auth/CreateAuth/CreateAuthorizationDetail/Proptypes';

export const checkSpecialistAuthHistory = (membKeyId: any, provKeyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_SPECIALIST_AUTH_HISTORY_REQUEST });

  return api.authorization.specialists.checkHistory(membKeyId, provKeyId)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_SPECIALIST_AUTH_HISTORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_SPECIALIST_AUTH_HISTORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const validateOPTOPH = (model: ValidateOPTOPHModel) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VALIDATE_OPT_OPH_REQUEST });

  return api.authorization.specialists.validateOPTOPH(model)
    .then((res: any) => {

      dispatch({
        type: types.VALIDATE_OPT_OPH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.VALIDATE_OPT_OPH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
